import 'babel-polyfill';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {ThemeProvider} from 'styled-components';
import React from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import moment from 'moment';

import {ApolloProvider} from 'react-apollo';
import client from './client';

import Navigation from './Navigation';
import MUITheme from './theme.js';

moment.locale('de');
injectTapEventPlugin();

let theme = MUITheme.palette;
theme.menuColor = '#efefef';

export default () => (
  <ThemeProvider theme={theme}>
    <MuiThemeProvider muiTheme={MUITheme}>
      <ApolloProvider client={client}>
        <Navigation />
      </ApolloProvider>
    </MuiThemeProvider>
  </ThemeProvider>
);



// WEBPACK FOOTER //
// ./src/App.js